import { h } from 'preact';

import { upgradeMovie } from 'utils/data';
import { confirm, toast } from 'utils/modal';
import { canUser } from 'utils/roles';

import Button from 'components/button/button';
import MovieInfoEditor from 'components/editor/movies/movieInfo/movieInfo';

export default class FocusMovieInfoEditor extends MovieInfoEditor {
	constructor(props) {
		super(props);

		this.onUpgradeMovieClick = this.onUpgradeMovieClick.bind(this);
	}

	// ===============
	// Fields
	// ===============

	renderHideFromCarousels() {
		return super.renderHideFromCarousels({
			label: 'Hide from "New and Upcoming Film Releases" section after date'
		});
	}

	renderShowtimesSource() {
		const requestShowtimesLink = 'https://form.asana.com/?k=7npeqUOv2Wr0ehX05wHGug&d=8582257821148';

		return (
			<div>
				{super.renderShowtimesSource()}
				<div>
					<span>Please request showtimes to ensure full and accurate screening coverage.</span>
					<Button
						key="requestShowtimes"
						href={requestShowtimesLink}
						target="_blank"
						rel="noopener noreferrer"
						iconAlt="chevron-right"
						primary
						text
					>
						Request showtimes
					</Button>
				</div>
			</div>
		);
	}

	// Placeholder
	renderFieldsPlaceholder() {
		return [
			this.renderTitle(),
			this.renderReleaseDate(),
			this.renderSlug(),
			this.renderExternalUrl(),
			this.renderGenre(),
		];
	}

	// Movie Platform
	renderFieldsMoviePlatform() {
		return [
			this.renderTitle(),
			this.renderReleaseDate(),
			this.renderTicketingDate(),
			this.renderHomeEntDate(),
			this.renderReleaseMessaging(),
			this.renderHideFromCarousels(),
			this.renderSlug(),
			this.renderExternalUrl(),
			this.renderShowtimesSource(),
			this.renderGenre(),
		];
	}

	// ===============
	// Actions
	// ===============

	// Placeholder
	async onUpgradeMovieClick() {
		const ok = await confirm('This will convert the placeholder to a full movie and enable all features. This action cannot be undone.', {
			title: 'Upgrade to full movie',
			button: 'Upgrade',
		});
		if (!ok) return;

		await upgradeMovie(this.props.data.id);

		toast('Movie upgraded successfully', { icon: 'check' });
	}

	renderUpgradeMovie() {
		return (
			<Button
				key="upgrade"
				disabled={!canUser('publish')}
				iconAlt="convert-circle"
				onClick={this.onUpgradeMovieClick}
				primary
			>
				Upgrade to full movie
			</Button>
			
		);
	}

	renderActionsPlaceholder() {
		return [
			this.renderUpgradeMovie(),
			this.renderDeletePlaceholder(),
		];
	}

	// Movie Platform
	renderActionsMoviePlatform() {}
}